/**
 * Cria e retorna uma função de comparação para dois textos (strings) dentro de objetos retornando o
 * valor de ordenação para uso com Array.sort.
 * Utiliza o localCompare nativo, que garante consistencia em comparações com diacríticos (acentos,
 * por exemplo).
 * @param {String} propertyAccessor Propriedade para ser acessada.
 * @returns {Funtion} Função de ordenação que retorna -1, 0 ou 1;
 */
export function localeCompareFor(propertyAccessor) {
  return (a, b) => (String(a[propertyAccessor] || ''))
    .localeCompare(String(b[propertyAccessor] || ''));
}

/**
 * Comparador de objetos para Array.sort que usa localeCompare através da propriedade name.
 */
export const localeCompareForName = localeCompareFor('name');

/**
 * Cria e retorna uma função de comparação para dois valores de qualquer tipo que estejam dentro de
 * objetos em uma array de objetos, retornando ordenação para Array.sort, -1, 0 e 1.
 * @param {String} propertyAccessor Propriedade para ser acessada.
 * @returns {Funtion} Função de ordenação que retorna -1, 0 ou 1;
 */
export function compareFor(propertyAccessor) {
  return (objA, objB) => {
    const valueA = objA[propertyAccessor];
    const valueB = objB[propertyAccessor];

    if (valueA < valueB) {
      return -1;
    }

    if (valueA > valueB) {
      return 1;
    }

    return 0;
  };
}
